/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

/**
 * NoFeePeriods.jsx
 * Created by michael bray on 3/21/18.
 */
import React from 'react';
import { gnoment } from 'shared-ui/gnoment';
import PropTypes from 'prop-types';
import { NoFeeDaysProps } from '../../props';

function NoFeePeriods({ noFeePeriods = [], siteName, agency }) {
    if (!noFeePeriods) return null;

    const sortedPeriods = noFeePeriods.sort((a, b) => gnoment(a.date).diff(b.date));
    return noFeePeriods && noFeePeriods.length ? (
        <section className="rec-order-detail-need-help">
            <h4 className="parkpass-section-heading h6">Fee Free Days</h4>
            <div className="pp-parkpasses-fees">
                {agency === 'NPS' ? (
                    <>
                        <p>
                            On Fee Free Days entrance fees are waived at this location for
                            U.S. citizens and residents. Non-residents will need to pay
                            the entrance fee and any applicable non-resident fees or
                            purchase an America the Beautiful Non-Resident Annual Pass
                            upon arrival.
                        </p>
                        <p>Mark your calendar for these entrance fee-free dates:</p>
                    </>
                ) : (
                    <p>Fees are waived at {siteName} on the following days:</p>
                )}

                <ul className="pp-parkpasses-fee-list">
                    {sortedPeriods.map(({ date, end, name }) => (
                        <li className="pp-parkpasses-fee-list-item" key={name}>
                            {gnoment(date.replace(/T.*/, '')).format('ll')}
                            {end
                                ? ` – ${gnoment(end.replace(/T.*/, '')).format('ll')}`
                                : ''}
                            : {name}
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    ) : null;
}

NoFeePeriods.propTypes = {
    noFeePeriods: NoFeeDaysProps,
    siteName: PropTypes.string,
};

export default NoFeePeriods;

// cspell:ignore parkpass, parkpasses
